<template>
  <div>
    <div class="add_godds_top">
      <el-steps :active="2" :space="246" align-center>
        <el-step title="选择商品分类"></el-step>
        <el-step title="填写商品信息"></el-step>
      </el-steps>
    </div>
    <div class="add_goods_cont">
      <div class="cont_left">
        <div class="cont_left_text" >
          <i class="iconfont icon-icon_favorite" style="font-size:18px"></i> 选择分类
          <div class="cont_left_icon"></div>
        </div>
      </div>
      <div class="cont_right">
        <el-form ref="form" :model="form" label-width="200px">
          <el-form-item></el-form-item>

          <el-form-item label="商品分类">{{name1}}>{{name2}}>{{name3}}</el-form-item>

          <el-form-item label="商品名称">
            <el-input style="width:50%" v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item label="常用名称">
            <el-input style="width:50%" v-model="form.common_title"></el-input>
          </el-form-item>
          <el-form-item label="品牌">
            <el-input style="width:50%" v-model="form.brand"></el-input>
          </el-form-item>
          <el-form-item label="货号">
            <el-input style="width:50%" v-model="form.item_no"></el-input>
          </el-form-item>
          <el-form-item label="货期">
            <el-input style="width:50%" v-model="form.leadtime"></el-input>
          </el-form-item>
          <el-form-item label="规格">
            <el-input style="width:50%" v-model="form.specification"></el-input>
          </el-form-item>
          <el-form-item label="型号">
            <el-input style="width:50%" v-model="form.model"></el-input>
          </el-form-item>
          <el-form-item label="应用">
            <el-input style="width:50%" v-model="form.uses"></el-input>
          </el-form-item>
          <el-form-item label="库存">
            <el-input style="width:50%" v-model="form.inventory"></el-input>
          </el-form-item>
          <el-form-item label="售价">
            <el-input style="width:50%" v-model="form.selling_price"></el-input>
          </el-form-item>
          <el-form-item label="原价">
            <el-input style="width:50%" v-model="form.original_price"></el-input>
          </el-form-item>

          <!-- <el-form-item label="说明文档">
            <el-upload
              class="upload-demo"
              :on-change="changeDoc"
              :auto-upload="false"
              :limit="1"
              action
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传pdf/word/wps文件,且不超过500kb</div>
            </el-upload>
          </el-form-item> -->

          <el-form-item label="图片">
            <el-upload
              list-type="picture-card"
              :on-change="changeImg"
              :auto-upload="false"
              :limit="1"
              action
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog>
              <img width="100%" alt />
            </el-dialog>
          </el-form-item>
          <el-form-item label="详情">
            <div id="editor1">
              <wangeditor @change_edit="change_edit1" />
            </div>
          </el-form-item>

          <el-form-item>
            <div style="margin: 20px auto 20px auto;width:100px">
              <el-button @click="submit" type="primary">确定上传</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import wangeditor from "../../components/wangeditor";
export default {
  components: {
    wangeditor
  },
  data() {
    return {
      info: null,
      form: {
        title: null,
        common_title: null,
        brand: null,
        item_no: null,
        leadtime: null,
        specification: null,
        model: null,
        uses: null,
        inventory: null,
        selling_price: null,
        original_price: null
      },
      doc: null,
      image: null,
      name1: this.$route.params.name1,
      name2: this.$route.params.name2,
      name3: this.$route.params.name3,
      f_id2: this.$route.params.f_id2,
      f_id3: this.$route.params.f_id3,
      f_id4: this.$route.params.f_id4,
      brands: [],
      value: "",
      token: this.$cookies.get("shop_token")
    };
  },
  created() {
    this.obj = this.$route.params;
  },
  mounted() {
     if(!this.name3){
        this.$router.push("/shop/addgoods")
     }
  },
  methods: {
    changeDoc(file) {
      this.doc = file.raw;
    },
    changeImg(file) {
      this.image = file.raw;
    },
    submit() {
      let config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      };
      const formData = new FormData();
      if (this.form.title != null) {
         formData.append("title", this.form.title);
      }
      if (this.form.common_title != null) {
        formData.append("common_title", this.form.common_title);
      }
      if (this.form.brand != null) {
          formData.append("brand", this.form.brand);
      }
      if (this.form.item_no != null) {
         formData.append("item_no", this.form.item_no);
      }
      if (this.form.leadtime != null) {
         formData.append("leadtime", this.form.leadtime);
      }
      if (this.form.specification != null) {
         formData.append("specification", this.form.specification);
      }
      if (this.form.model != null) {
         formData.append("model", this.form.model);
      }
      if (this.form.uses != null) {
         formData.append("uses", this.form.uses);
      }
      if (this.form.inventory != null) {
        formData.append("inventory", this.form.inventory);
      }
      if (this.form.selling_price != null) {
        formData.append("selling_price", this.form.selling_price);
      }
      if (this.form.original_price != null) {
        formData.append("original_price", this.form.original_price);
      }
      if (this.info != null) {
         formData.append("info", this.info);
      }
      if (this.doc != null) {
         formData.append("doc", this.doc);
      }
      formData.append("token", this.token);
      formData.append("top_class", this.name1);
      formData.append("third_class", this.name2);
      formData.append("second_class", this.name3);
      formData.append("image", this.image);

      this.axios
        .post(this.$store.state.serve + "shop/insert_product", formData, config)
        .then(res => {
          if(res.data.status == 'success'){
             this.$alerts.success('上传成功',this.$message)
          }else if(res.data.status == 'error'){
               this.$alerts.error(res.data.msg ,this.$message)
          }
        });
    },
    change_edit1(data) {
      this.info = data;
    }
  }
};
</script>
<style lang='scss'>
.add_godds_top {
  width: 500px;
  margin: 0 auto;
  .ve-toolbar {
    display: flex;
    align-items: center;
  }
  .is-text {
    width: 54px;
    height: 54px;
  }
  .el-step__line {
    position: absolute !important;
    top: 26px !important;
  }
}
.add_goods_cont {
  margin-top: 33px;
  width: 100%;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(221, 221, 221, 1);
  margin-bottom: 86px;
  display: flex;
  .cont_left {
    width: 182px;
    //  height: 100%;
    background: rgba(238, 238, 238, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
    position: relative;
    .cont_left_text {
      width: 100%;
      height: 54px;
      background: rgba(166, 182, 193, 1);
      position: absolute;
      left: 0;
      top: 80px;
      font-size: 18px;
      font-family: "Microsoft YaHei";
      text-align: center;
      line-height: 54px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      .cont_left_icon {
        width: 0;
        height: 0;
        border-left: 39px solid #a6b6c1;
        border-bottom: 39px solid transparent;
        transform: rotate(135deg);
        position: absolute;
        right: -19px;
        top: 8px;
      }
    }
  }
  .cont_right {
    width: 80%;
    height: 100%;
  }
}
</style>